/* eslint-disable react/no-danger */
import React from 'react';
import PropTypes from 'prop-types';
import {gql} from 'apollo-boost';
import {Query} from 'react-apollo';
import {fieldObjectSectionStyle} from "../../helpers/graphQLShortcuts";
import {fieldObjectSectionStyleCss} from "../../helpers/createStyles";
import {filterHeadline, filterResource} from "../../helpers/filters";
import './CenteredPictureCarousel.scss';

class CenteredPictureCarouselQuery extends Query<{id: string}> {}

const GET_COMPONENT = gql`
query paragraphById($id: String!) {
  paragraphById:paragraphRevisionById(id: $id) {
    ... on Paragraph {
      ... on Paragraph {
        ... on ParagraphComponentCenteredPictureCarou {
          fieldObjectSectionStyle {
              ${fieldObjectSectionStyle}
          }
          fieldTxtHeadline 
          fieldImages {
            targetRevisionId
              entity {
                ... on ParagraphInnerImage {
                  fieldObjectImgMedia {
                      entity {
                        ... on MediaImage {
                          fieldMediaImage {
                            width
                            height
                            url
                            alt
                            title
                          }
                        }
                      }
                  }
                }
              }
          }
        }
      }
    }
  }
}
`;

// eslint-disable-next-line no-unused-vars
const CenteredPictureCarousel = ({id, markComponentLoadedAs, handleLoadedComponents}) => (
    <CenteredPictureCarouselQuery asyncMode query={GET_COMPONENT} variables={{ id }}>
        {({ loading, error, data }) => {
            if (loading) return null;
            if (error) {
                markComponentLoadedAs(id, true);
                return <div>{error}</div>;
            }

            const field = data.paragraphById;

            // Generate Styles Object
            const styles = fieldObjectSectionStyleCss(field.fieldObjectSectionStyle);

            const cssId = field && field.fieldObjectSectionStyle && field.fieldObjectSectionStyle.entity && field.fieldObjectSectionStyle.entity.fieldCssId ? field.fieldObjectSectionStyle.entity.fieldCssId : null;

            // Ensure an Image Exists
            if (!(field && field.fieldImages && field.fieldImages.length && field.fieldImages[0] && field.fieldImages[0].targetRevisionId)) return null;

            markComponentLoadedAs(id, true);

            return (
                <section className={`photoCarousel photoCarouselComponent${styles.classNames}`} style={styles.css} id={cssId}>

                    {styles.childBackground.isActive && (
                        <div className="generalContent__background" style={styles.childBackground.css}/>
                    )}

                    <div className="container">
                    {field.fieldTxtHeadline && (
                        <div className="photoCarousel__header careersSection__header">
                            <h2 style={field.fieldHeadlineColor ? {color: field.fieldHeadlineColor} : null} dangerouslySetInnerHTML={{__html: filterHeadline(field.fieldTxtHeadline)}} />
                        </div>
                    )}


                    <div className="photoCarousel__container">
                        <div className="photoCarousel__carousel swiper">
                            <div className="photoCarousel__wrapper swiper-wrapper">
                                {field.fieldImages && field.fieldImages.filter(image => image.entity.fieldObjectImgMedia.entity.fieldMediaImage.url !== '').map(image => (
                                    <div className="photoCarousel__card swiper-slide">
                                        <img key={`image_${image.targetRevisionId}`}
                                             src={filterResource(image.entity.fieldObjectImgMedia.entity.fieldMediaImage.url)}
                                             alt={image.entity.fieldObjectImgMedia.entity.fieldMediaImage.title || image.entity.fieldObjectImgMedia.entity.fieldMediaImage.alt}/>
                                    </div>
                                ))}
                            </div>
                        </div>

                        <button className="swiper-button-prev photoCarousel-swiper-button-prev"/>
                        <button className="swiper-button-next photoCarousel-swiper-button-next"/>

                        <div className="swiper-pagination photoCarousel-swiper-pagination"/>
                    </div>
                    </div>
                </section>
            );
        }}
    </CenteredPictureCarouselQuery>
);

CenteredPictureCarousel.propTypes = {
    id: PropTypes.number.isRequired,
    markComponentLoadedAs: PropTypes.func.isRequired,
    handleLoadedComponents: PropTypes.func.isRequired
};

export default CenteredPictureCarousel;



// WEBPACK FOOTER //
// ./frontend/components/CenteredPictureCarousel/CenteredPictureCarousel.jsx